<template>
  <section class="profile-section">
    <NavigationBar />

    <!-- desktop -->
    <div
      v-if="!isVerySmall"
      class="uk-section uk-padding-remove-top uk-margin-top"
    >
      <div class="uk-container uk-margin-top">
        <div class="uk-flex" uk-grid>
          <NavigationProfile />
          <div class="uk-width-expand">
            <h3>My Profile</h3>
            <hr />
            <div uk-grid v-if="!loading">
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5">
                  <div>Email</div>
                </div>
                <div class="uk-width-1-2">
                  <!-- <div><input type="text" class="uk-input" disabled></div> -->
                  <div>{{ userData.email }}</div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5">
                  <div>Fullname</div>
                </div>
                <div class="uk-width-1-2">
                  <div>
                    <input
                      type="text"
                      class="uk-input"
                      v-model="userData.fullname"
                    />
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5">
                  <div>Phone</div>
                </div>
                <div class="uk-width-1-2">
                  <div v-if="userData.verification_phone == '1'">
                    {{ userData.phone }}
                  </div>
                  <div v-else>
                    <input
                      type="number"
                      class="uk-input uk-form-danger"
                      v-model="userData.phone"
                    /><span class="text-error"
                      >Phone number has not been verified!</span
                    >
                    <router-link to="/profile/verification_phone" style="font-size: 12px;margin-left: 10px;">Verify Now!</router-link>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5">
                  <div>Birthday</div>
                </div>
                <div class="uk-width-1-2 uk-flex" uk-grid>
                  <div class="uk-width-1-4">
                    <select
                      name="day"
                      id="day"
                      class="uk-select"
                      v-model="userData.day"
                    >
                      <option
                        :value="value"
                        v-for="(value, i) in dayData"
                        :key="i"
                      >
                        {{ value }}
                      </option>
                    </select>
                  </div>
                  <div class="uk-width-1-3">
                    <select
                      name="month"
                      id="month"
                      class="uk-select"
                      v-model="userData.month"
                    >
                      <option
                        :value="month.value"
                        v-for="(month, i) in monthData"
                        :key="i"
                      >
                        {{ month.label }}
                      </option>
                    </select>
                  </div>
                  <div class="uk-width-1-4">
                    <select
                      name="year"
                      id="year"
                      class="uk-select"
                      v-model="userData.year"
                    >
                      <option
                        :value="year"
                        v-for="(year, i) in yearData"
                        :key="i"
                      >
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5">
                  <div>Gender</div>
                </div>
                <div class="uk-width-1-2">
                  <div class="uk-form-controls">
                    <label style="cursor: pointer"
                      ><input
                        class="uk-radio"
                        type="radio"
                        name="gender"
                        value="L"
                        v-model="userData.gender"
                      />
                      Man</label
                    ><br />
                    <label style="cursor: pointer"
                      ><input
                        class="uk-radio"
                        type="radio"
                        name="gender"
                        value="P"
                        v-model="userData.gender"
                      />
                      Woman</label
                    >
                  </div>
                </div>
              </div>
              <div class="uk-width-1-1 uk-flex uk-margin-top">
                <div class="uk-width-1-5"></div>
                <div class="uk-width-1-2">
                  <div>
                    <button class="uk-button uk-button-primary" @click="submit()">Save</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="uk-width-expand uk-flex uk-flex-center uk-flex-middle"
              v-else
            >
              <div class="">
                <div uk-spinner></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- mobile -->
    <div class="uk-section uk-padding-remove-top uk-margin-top" v-else>
      <div class="uk-container">
        <div class="uk-width-expand">
          <h3>My Profile</h3>
          <hr />
          <div uk-grid v-if="!loading">
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5">
                <div>Email</div>
              </div>
              <div class="uk-width-1-2">
                <!-- <div><input type="text" class="uk-input" disabled></div> -->
                <div>{{ userData.email }}</div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5">
                <div>Fullname</div>
              </div>
              <div class="uk-width-expand">
                <div>
                  <input
                    type="text"
                    class="uk-input"
                    v-model="userData.fullname"
                  />
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5">
                <div>Phone</div>
              </div>
              <div class="uk-width-expand">
                <div v-if="userData.verification_phone == '1'">
                  {{ userData.phone }}
                </div>
                <div v-else>
                  <input
                    type="number"
                    class="uk-input uk-form-danger"
                    v-model="userData.phone"
                  /><span class="text-error"
                    >Phone number has not been verified!</span
                  >
                  <router-link to="/profile/verification_phone" style="font-size: 12px;margin-left: 10px;">Verify Now!</router-link>
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5">
                <div>Birthday</div>
              </div>
              <div class="uk-width-expand uk-flex" uk-grid>
                <div class="uk-width-1-4">
                  <select
                    name="day"
                    id="day"
                    class="uk-select"
                    v-model="userData.day"
                  >
                    <option
                      :value="value"
                      v-for="(value, i) in dayData"
                      :key="i"
                    >
                      {{ value }}
                    </option>
                  </select>
                </div>
                <div class="uk-width-expand">
                  <select
                    name="month"
                    id="month"
                    class="uk-select"
                    v-model="userData.month"
                  >
                    <option
                      :value="month.value"
                      v-for="(month, i) in monthData"
                      :key="i"
                    >
                      {{ month.label }}
                    </option>
                  </select>
                </div>
                <div class="uk-width-1-3">
                  <select
                    name="year"
                    id="year"
                    class="uk-select"
                    v-model="userData.year"
                  >
                    <option
                      :value="year"
                      v-for="(year, i) in yearData"
                      :key="i"
                    >
                      {{ year }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5">
                <div>Gender</div>
              </div>
              <div class="uk-width-1-2">
                <div class="uk-form-controls">
                  <label style="cursor: pointer"
                    ><input
                      class="uk-radio"
                      type="radio"
                      name="gender"
                      value="L"
                      v-model="userData.gender"
                    />
                    Man</label
                  ><br />
                  <label style="cursor: pointer"
                    ><input
                      class="uk-radio"
                      type="radio"
                      name="gender"
                      value="P"
                      v-model="userData.gender"
                    />
                    Woman</label
                  >
                </div>
              </div>
            </div>
            <div class="uk-width-1-1 uk-flex uk-margin-top">
              <div class="uk-width-1-5"></div>
              <div class="uk-width-1-2">
                <div>
                  <button class="uk-button uk-button-primary" @click="submit()">Save</button>
                </div>
              </div>
            </div>
          </div>
          <div
            class="uk-width-expand uk-flex uk-flex-center uk-flex-middle"
            v-else
          >
            <div class="">
              <div uk-spinner></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavigationProfile from "@/components/NavigationProfile.vue";
import { mapGetters, mapMutations } from "vuex";
import $axios from "../../api";
import UIkit from 'uikit'

export default {
  components: {
    NavigationBar,
    Footer,
    NavigationProfile,
  },
  data() {
    return {
      userData: null,
      loading: true,
      monthData: [
        {
          label: "January",
          value: 1,
        },
        {
          label: "February",
          value: 2,
        },
        {
          label: "March",
          value: 3,
        },
        {
          label: "April",
          value: 4,
        },
        {
          label: "May",
          value: 5,
        },
        {
          label: "June",
          value: 6,
        },
        {
          label: "July",
          value: 7,
        },
        {
          label: "August",
          value: 8,
        },
        {
          label: "September",
          value: 9,
        },
        {
          label: "October",
          value: 10,
        },
        {
          label: "November",
          value: 11,
        },
        {
          label: "December",
          value: 12,
        },
      ],
      dayData: [],
      yearData: [],
    };
  },
  mounted() {
    if (!this.IS_AUTH) {
      this.$router.push(
        `/?login=true&back=${window.location.origin + this.$route.path}`
      );
    } else {
      this.getDataUser()
    }
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    }
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    submit() {
      if (this.GET_USER.verification_phone == 1) {
        $axios.post('customer/auth/update_profile', {
          id_cust: this.GET_USER.id,
          fullname: this.userData.fullname,
          gender: this.userData.gender,
          birthday: `${this.userData.year}-${this.userData.month}-${this.userData.day}`
        }).then((res) => {
          if (res.status == 200) {
            const data = res.data
            if (data.success == 1) {
              this.userData.birthday = `${this.userData.year}-${this.userData.month}-${this.userData.day}`
              this.SET_USER(this.userData)
              UIkit.notification({
                status: 'success',
                message: 'Profile update was successful!'
              })
              this.$root.$emit('NavigationBar')
            } else {
              UIkit.notification({
                status: 'danger',
                message: data.msg
              })
            }
          } else {
            console.log(res.status)
            UIkit.notification({
              status: 'danger',
              message: 'Something went wrong'
            })
          }
        }).catch((err) => {
          console.warn(err)
          UIkit.notification({
            status: 'danger',
            message: 'Something went wrong'
          })
        });
      } else {
      }
    },
    getDataUser() {
      const userData = this.GET_USER
      this.SET_USER(this.GET_USER)
      this.userData = userData;
      if (this.userData.birthday) {
        const birthday = this.userData.birthday.split("-");
        this.userData.day = Number(birthday[2]);
        this.userData.year = Number(birthday[0]);
        this.userData.month = Number(birthday[1]);
      } else {
        this.userData.day = '1'
        this.userData.year = '1969'
        this.userData.month = '1'
      }
      for (let i = 1; i <= 31; i++) {
        this.dayData.push(i);
      }
      const d = new Date();
      const thisYear = d.getFullYear();
      for (let y = 1969; y <= thisYear; y++) {
        this.yearData.push(y);
      }
      this.loading = false;
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../custom/custom.less";

.profile-section {
  .text-error {
    color: @danger-color;
    font-size: 12px;
  }

  select,
  input[type="radio"] {
    cursor: pointer;
  }
}
</style>